const newRoutes = [
    // {
    //     path: '/homePage/homePage',
    //     name: 'HomePage',
    //     component: () => import('../newViews/homePage/index.vue'),
    //     meta: {
    //         title: '首页'
    //     }
    // },
    {
        // path: '/goods/saleGoodsDetail',
        component: () => import('../views/LayOut/simple.vue'),
        path: '/homePage',
        redirect: '/homePage/homePage',
        children: [
            {
                path: 'goodsSearch',
                name: 'GoodsSearch',
                component: () => import('../newViews/homePage/goodsSearch.vue'),
                meta: {
                    title: '商品搜索'
                }
            },
            {
                path: 'doorDetail',
                name: 'DoorDetail',
                component: () => import('../newViews/homePage/doorDetail.vue'),
                meta: {
                    title: '门店详情'
                }
            },
        ]
    },
    {
        // path: '/goods/saleGoodsDetail',
        component: () => import('../views/LayOut/simple.vue'),
        path: '/goods',
        redirect: '/goods/saleGoodsDetail',
        children: [
            {
                path: 'saleGoodsDetail/:id',
                name: 'SaleGoodsDetail',
                component: () => import('../newViews/goods/saleGoodsDetail')
            },
            {
                path: 'saleConfirmMenu',
                name: 'SaleConfirmMenu',
                component: () => import('../newViews/goods/saleConfirmMenu')
            },
            {
                path: 'payList',
                name: 'PayList',
                component: () => import('../newViews/goods/payList'),
                 meta: {
                    title: '支付'
                }
            },
             {
                path: 'payWebview',
                name: 'payWebview',
                component: () => import('../newViews/goods/payWebview'),
                meta: {
                    title: '支付'
                }
            },
            {
                path:'preOrderInfo',
                name:'PreOrderInfo',
                component: () => import('../newViews/goods/preOrderInfo')
            },
            {
                path: 'bindCard',
                name: 'BindCard',
                component: () => import('../newViews/goods/bindCard')
            },
            {
                path: 'shoppingCard',
                name: 'ShoppingCard',
                component: () => import('../newViews/goods/shoppingCard')
            },
            // {
            //     path: 'order',
            //     name: 'Order',
            //     component: () => import('../newViews/goods/order'),
            //     meta: {
            //         title: '订单列表'
            //     }
            // },
            {
                path: 'orderDetail',
                name: 'OrderDetail',
                component: () => import('../newViews/goods/orderDetail'),
                meta: {
                    title: '订单详情'
                }
            },
            {
                path: 'applyDrawback',
                name: 'ApplyDrawback',
                component: () => import('../newViews/goods/applyDrawback'),
                meta: {
                    title: '申请退款'
                }
            },
            {
                path: 'drawbackDetail/:id',
                name: 'DrawbackDetail',
                component: () => import('../newViews/goods/drawbackDetail'),
                meta: {
                    title: '退款详情'
                }
            },
        ]
    },
    {
        // path: '/goods/saleGoodsDetail',
        component: () => import('../views/LayOut/simple.vue'),
        path: '/member',
        redirect: '/member/myMemberCard',
        children: [
            {
                path: 'myMemberCard',
                name: 'MyMemberCard',
                component: () => import('../newViews/member/myMemberCard'),
                meta: {
                    title: '我的会员卡'
                }
            },
            {
                path: 'handleEleCard',
                name: 'HandleEleCard',
                component: () => import('../newViews/member/handleEleCard'),
                meta: {
                    title: '办理会员卡'
                }
            },
            {
                path: 'cardRecharge',
                name: 'CardRecharge',
                component: () => import('../newViews/member/cardRecharge'),
                meta: {
                    title: '会员卡充值'
                }
            },
            {
                path: 'cardPay',
                name: 'CardPay',
                component: () => import('../newViews/member/cardPay'),
                meta: {
                    title: '会员卡充值'
                }
            },
            {
                path: 'bindRealCard',
                name: 'BindRealCard',
                component: () => import('../newViews/member/bindRealCard'),
                meta: {
                    title: '绑定实体卡'
                }
            },
            {
                path: 'cardManage',
                name: 'CardManage',
                component: () => import('../newViews/member/cardManage'),
                meta: {
                    title: '会员卡办理'
                }
            },
            {
                path: 'membershipCardDetails',
                name: 'MembershipCardDetails',
                component: () => import('../newViews/member/MembershipCardDetails'),
                meta: {
                    title: '会员卡详情'
                }
            },
        ]
    },
    // {
    //     component: () => import('../views/LayOut/simple.vue'),
    //     path: '/personCenter',
    //     redirect: '/personCenter/index',
    //     children: [
    //         {
    //             path: 'index',
    //             name: 'PersonCenter',
    //             component: () => import('../newViews/personCenter/personCenter'),
    //             meta: {
    //                 title: '个人中心'
    //             }
    //         },
    //     ]
    // },
    {
        // path: '/goods/saleGoodsDetail',
        component: () => import('../views/LayOut/simple.vue'),
        path: '/scanCode',
        redirect: '/scanCode/takeNumberResult',
        children: [
            {
                path: 'takeNumberResult',
                name: 'TakeNumberResult',
                component: () => import('../newViews/scanCode/takeNumberResult'),
                meta: {
                    title: ''
                }
            },
        ]
    },
    {
        // path: '/goods/saleGoodsDetail',
        component: () => import('../views/LayOut/simple.vue'),
        path: '/consumeCodeInfo',
        redirect: '/consumeCodeInfo/index',
        children: [
            {
                path: 'index',
                name: 'ConsumeCodeInfo',
                component: () => import('../newViews/consumeCodeInfo/index'),
                meta: {
                    title: '自助服务'
                }
            },
        ]
    },
     {
        // path: '/goods/saleGoodsDetail',
        component: () => import('../views/LayOut/simple.vue'),
        path: '/settleAccounts',
        redirect: '/settleAccounts/index',
        children: [
            {
                path: 'index',
                name: 'SettleAccounts',
                component: () => import('../newViews/settleAccounts/index'),
                meta: {
                    title: '自助结账'
                }
            },
            {
                path: 'handCardPay',
                name: 'HandCardPay',
                component: () => import('../newViews/settleAccounts/handCardPay'),
                meta: {
                    title: '自助结账'
                }
            },
        ]
    },
    
    {
        // path: '/goods/saleGoodsDetail',
        component: () => import('../views/LayOut/simple.vue'),
        path: '/SelfHelp',
        children: [
            {
                path: 'inputPeopleNum',
                name: 'InputPeopleNum',
                component: () => import('../views/SelfHelp/InputPeopleNum'),
                meta: {
                    title: '选择人数'
                }
            },
             {
                path: 'NewInputPeopleNum',
                name: 'NewInputPeopleNum',
                component: () => import('../views/SelfHelp/NewInputPeopleNum'),
                meta: {
                    title: '选择人数'
                }
            },
            {
                path: 'foodOrderInfo',
                name: 'FoodOrderInfo',
                component: () => import('../views/SelfHelp/FoodOrderInfo'),
                meta: {
                    title: '订单详情'
                }
            },
            {
                path: 'shareTable',
                name: 'ShareTable',
                component: () => import('../views/SelfHelp/ShareTable'),
                meta: {
                    title: '拼桌'
                }
            },
            {
                path: 'selectTeam',
                name: 'SelectTeam',
                component: () => import('../views/SelfHelp/SelectTeam'),
                meta: {
                    title: '选同伴'
                }
            },
            
        ]
    },
    {
        // path: '/goods/saleGoodsDetail',
        component: () => import('../views/LayOut/simple.vue'),
        path: '/payResult',
        redirect: '/payResult/index',
        children: [
            {
                path: 'index',
                name: 'PayResult',
                component: () => import('../newViews/payResult/index'),
                meta: {
                    title: '支付结果'
                }
            },
        ]
    },
    {
        // path: '/goods/saleGoodsDetail',
        component: () => import('../views/LayOut/simple.vue'),
        path: '/fromWechatProgram',
        redirect: '/fromWechatProgram/index',
        children: [
            {
                path: 'index',
                name: 'FromWechatProgram',
                component: () => import('../newViews/fromWechatProgram/index'),
                meta: {
                    title: ''
                }
            },
        ]
    },
    {
        // path: '/goods/saleGoodsDetail',
        component: () => import('../views/LayOut/simple.vue'),
        path: '/bookRegister',
        redirect: '/bookRegister/menu',
        children: [
            {
                path: 'menu',
                name: 'BookRegisterMenu',
                component: () => import('../newViews/bookRegister/menu'),
                meta: {
                    title: '预约挂号'
                }
            },
            
            {
                path: 'jishi',
                name: 'SelectJishi',
                component: () => import('../newViews/bookRegister/selectJishi'),
                meta: {
                    title: '预约挂号'
                }
            },
            {
                path: 'period',
                name: 'SelectPeriod',
                component: () => import('../newViews/bookRegister/selectPeriod'),
                meta: {
                    title: '预约挂号'
                }
            },
            {
                path: 'orderInfo',
                name: 'BookRegisterOrderInfo',
                component: () => import('../newViews/bookRegister/orderInfo'),
                meta: {
                    title: '信息确认'
                }
            },
            {
                path: 'resultPage',
                name: 'BookRegisterResult',
                component: () => import('../newViews/bookRegister/resultPage'),
                meta: {
                    title: '预约结果'
                }
            },
            {
                path: 'historyPage',
                name: 'BookHistoryPage',
                component: () => import('../newViews/bookRegister/historyPage'),
                meta: {
                    title: '预约挂号记录'
                }
            },
            {
                path: 'orderDetail',
                name: 'BookRegisterOrderDetail',
                component: () => import('../newViews/bookRegister/orderDetail'),
                meta: {
                    title: '号单详情'
                }
            },
        ]
    },
    
    
    {
        path: '/test',
        component: () => import('../views/LayOut/simple.vue'),
        redirect: '/test/test1',
        children: [
            {
                path: 'test1',
                name: 'Test1',
                component: () => import('../newViews/test/test1.vue')
            },
            {
                path: 'test2',
                name: 'Test2',
                component: () => import('../newViews/test/test2.vue')
            }
        ]
    },
]

export default newRoutes;